"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.createQueryDocument = void 0;
var tracing_js_1 = require("@web3api/tracing-js");
var graphql_tag_1 = __importDefault(require("graphql-tag"));
/** Create a GraphQL QueryDocument by parsing a string */
exports.createQueryDocument = tracing_js_1.Tracer.traceFunc("core: createQueryDocument", function (query) {
    return graphql_tag_1.default(query);
});
//# sourceMappingURL=Query.js.map